import { render, staticRenderFns } from "./SlotTable.vue?vue&type=template&id=54a9e892&scoped=true"
import script from "./SlotTable.vue?vue&type=script&lang=js"
export * from "./SlotTable.vue?vue&type=script&lang=js"
import style0 from "./SlotTable.vue?vue&type=style&index=0&id=54a9e892&prod&scoped=true&lang=css"
import style1 from "./SlotTable.vue?vue&type=style&index=1&id=54a9e892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9e892",
  null
  
)

export default component.exports